import useAuth from 'lib/hooks/use-auth';

function getNavigation(plan, isAuthenticated, isAdmin) {
    const routes = [];
    const navigation = { routes };

    const {
        meta: { data }
    } = useAuth();

    if (!isAuthenticated) return navigation;
    routes.push(
        ...[
            {
                name: _t.navigation.itineraries(),
                to: '/manage/itinerary'
            },
            {
                name: _t.navigation.connections(),
                to: '/manage/connections'
            },
            {
                name: _t.navigation.profiles(),
                to: '/manage/profiles'
            },
            {
                name: _t.navigation.templates(),
                to: '/manage/templates'
            }
        ]
    );
    if (data?.mainUser)
        routes.push({
            name: _t.navigation.users(),
            to: '/manage/users'
        });

    if (isAdmin)
        routes.push(
            ...[
                {
                    name: _t.navigation.themes(),
                    to: '/manage/theme'
                },
                {
                    name: _t.navigation.intl(),
                    to: '/manage/intl'
                },
                {
                    name: _t.navigation.intlThemes(),
                    to: '/manage/themetexts'
                },
                {
                    name: _t.navigation.admin(),
                    to: '/manage/admin'
                }
            ]
        );

    return navigation;
}

export default function useNavigation() {
    const {
        meta: { data },
        isAuthenticated
    } = useAuth();
    const plan = data?.plan;
    const admin = data?.admin;

    return getNavigation(plan, isAuthenticated, admin);
}
